import React from "react";
import { CV } from "../components/cv";
import MagnusCImg from "@/assets/images/magnus-c.png";

export default function CVMagnusChristiansson() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Magnus Christiansson";
  }, []);

  return (
    <CV
      name="Magnus Christiansson"
      title="Developer and Platform Engineer · Co-founder"
      subtitle="Platform engineering and developer effectiveness — product owner for IKEA's internal developer portal"
      photo={MagnusCImg}
      quote={{
        text: "I've had the pleasure of working with Magnus across several roles at IKEA. Magnus brings a combination of deep technical expertise and strategic thinking. He's great at keeping the eyes on the bigger picture, even when navigating complex challenges and projects. Good ability to bring structure to ambiguity without slowing things down. He makes the work clearer for everyone around him and is always close to a whiteboard to visualize and get everyone onboard. Beyond the technical skills, Magnus is collaborative — he both listens, engages, and drives things forward to get results that work for all parts. Working with him in his capacity as a product owner, I saw firsthand how he balances stakeholder needs, technical realities, and long-term vision with confidence.",
        author: "Björn Ramberg",
        authorTitle: "IKEA",
      }}
      summary="Developer and Platform Engineer. Passionate about product development, developer effectiveness and experience, Platform engineering and getting things done. Co-founder of BoldBrave."
      skills={{
        "Languages": ["JavaScript", "TypeScript", "Golang"],
        "Cloud & Infra": ["GCP", "AWS", "Docker", "Kubernetes", "Openshift", "Serverless"],
        "Tools": ["Terraform", "Ansible", "Hashicorp Vault", "Backstage", "Git", "Redis"],
        "Methods": ["Platform Engineering", "DevOps", "Open- and Innersource"],
      }}
      experience={[
        {
          role: "Solution architect / Product owner",
          company: "IKEA IT",
          period: "2017 - Present",
          description:
            "Leading platform development and developer experience initiatives at IKEA IT.",
          highlights: [
            "Product owner (2021 - Present): Establishing and developing IKEA's internal developer portal based on Backstage. Serving IKEA product teams globally, providing easy access to platforms, aiming for improved reuse, effectiveness and resiliency across the software supply chain",
            "Solution architect (2019 - 2021): Platform area focusing on continuous integration and delivery capabilities supporting product teams at IKEA. Providing tooling, platforms and consultancy services",
            "Solution architect (2017 - 2019): Web and ecommerce IKEA.com",
          ],
        },
        {
          role: "Digital strategist and project manager",
          company: "Knowit Experience",
          period: "2016 - 2017",
          description:
            "Digital strategist and project manager in ecommerce and web projects. Combining project management with digital strategy advisory and supporting sales.",
        },
        {
          role: "Developer and Director",
          company: "Avensia",
          period: "2011 - 2016",
          description:
            "Full-stack implementation of open-data portals powered by CKAN. Contributed to CKAN and the CKAN ecosystem.",
          highlights: [
            "Development director and developer (2014 - 2016): Manager for Lund office",
            "Developer (2011 - 2013): Worked as web developer in various web/ecommerce projects, B2C and B2B, for the Nordic market. Focus on frontend / UX related",
          ],
        },
        {
          role: "Project manager",
          company: "Sony Mobile Communications",
          period: "2007 - 2011",
          description:
            "Project management in various phone products, focus on messaging and social media apps.",
        },
        {
          role: "Embedded software developer",
          company: "Enea",
          period: "2005 - 2007",
          description:
            "Various contract assignments within mobile phone industry.",
        },
        {
          role: "Embedded software developer",
          company: "Teleca Software Solutions AB",
          period: "2001 - 2005",
          description:
            "Various in-house projects in Sweden and abroad integrating web browsers in clients mobile phone devices.",
        },
      ]}
      education={[
        {
          degree: "M.Sc Computer Science",
          institution: "The Faculty of Engineering at Lund University",
          year: "1996 - 2001",
        },
        {
          degree: "Naturvetenskaplig linje",
          institution: "Katedralskolan, Lund",
          year: "1992 - 1995",
        },
      ]}
    />
  );
}
